<script lang="ts">
import { defineComponent } from "vue";
import IconSprite from "@/components/IconSprite.vue";
import { inject } from "vue";
import router from "@/router";

export default defineComponent({
  name: "TimeoutModal",
  components: { IconSprite },
  emits: ["retry"],
  props: {
    ersteSeite: String,
  },
  setup(props, { emit }) {
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");

    function closeModal() {
      wechsleSichtbarkeit("modal-timeout");
      router.push(props.ersteSeite as string);
    }

    function erneutVersuchen() {
      wechsleSichtbarkeit("modal-timeout");
      emit("retry");
    }

    return {
      closeModal,
      erneutVersuchen,
    };
  },
});
</script>

<template>
  <div class="c-modal" id="modal-angebot-per-mail">
    <section class="c-modal__content">
      <header class="c-modal__header">
        <h1 class="c-modal__title">
          <slot name="titel">Verzögerte Antwort</slot>
        </h1>
        <button type="button" class="c-button c-button--icon-only-white" @click="closeModal()">
          <icon-sprite icon-name="icon-cross" />
          <span class="c-button__visually-hidden">close</span>
        </button>
      </header>
      <section class="c-modal__content-section u-text-align-left">
        <div class="o-grid o-grid--align-middle">
          <div class="o-grid__cell o-grid__cell--1">
            <icon-sprite icon-name="icon-delete-item" :ist-gross="true" css-style="color: red" />
          </div>
          <div class="o-grid__cell o-grid__cell--11">
            Die Antwort auf eine Anfrage im Hintergrund dauerte länger als erwartet.<br />
            Wollen Sie es erneut versuchen?
          </div>
          <div class="o-grid__cell o-grid__cell--6 form-actions u-mar-b-0 u-text-align-left">
            <button class="c-button c-button--inverted" type="button" @click="closeModal()">Abbrechen</button>
          </div>
          <div class="o-grid__cell o-grid__cell--6 form-actions u-mar-b-0 u-text-align-right">
            <button class="c-button right" type="button" @click="erneutVersuchen()">Erneut versuchen</button>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<style scoped></style>
